import { graphql } from "gatsby"
import useTranslations from "hooks/useTranslations"
import { formatArticles, formatTestimonial } from "utils/prismic"
import SEO from "components/seo"
import Hero from "components/organisms/somebuddy/Hero"
import Impact from "components/organisms/somebuddy/Impact"
import Media from "components/organisms/somebuddy/ListHorizontal"
import Testimonials from "components/organisms/somebuddy/Testimonials"
import Problems from "components/variants/ProblemsPro"
import Service from "components/variants/ServicePro"
import BlogPosts from "components/organisms/common/BlogPosts"
import HowDoWeHelpPro from "components/variants/HowDoWeHelpPro"
import QuotesCarousel from "components/variants/QuotesCarouselPro"
import LogoCloudAnimated from "components/organisms/LogoCloudAnimated"
import Contact from "components/organisms/somebuddy/Contact"
import "styles/index.global.css"

const ProPage = ({ data, pageContext: { currentPage } }) => {
  const { pageHrTitle } = useTranslations()

  const prismicArticles =
    data && data.allPrismicNewsArticle
      ? data.allPrismicNewsArticle
      : { edges: [] }
  const articles = formatArticles(prismicArticles)

  const testimonials = data.allPrismicTestimonial.nodes.map((t) =>
    formatTestimonial({ id: t.uid, ...t.data }),
  )

  return (
    <>
      <SEO title={pageHrTitle} />
      <div className="sections">
        <Hero />
        <BlogPosts />
        <Problems reversed theme="light" />
        <Impact />
        <Service />
        <QuotesCarousel bgColor="black" />
        <HowDoWeHelpPro />
        <Testimonials list={testimonials} />
        <LogoCloudAnimated center currentPage={currentPage} />
        <Contact />
        <Media items={articles} allItemsLink="/media" theme="light" />
      </div>
    </>
  )
}

export default ProPage

export const pageQuery = graphql`
  query ($locale: String!, $wellKnownMedia: [String]!, $currentPage: String!) {
    allPrismicNewsArticle(
      sort: { data: { published_at: DESC } }
      limit: 3
      filter: {
        lang: { eq: $locale }
        data: { publisher_name: { text: { in: $wellKnownMedia } } }
      }
    ) {
      edges {
        node {
          id
          data {
            article {
              text
            }
            published_at(formatString: "DD.MM.YYYY")
            link_to_article {
              url
            }
            publisher_logo {
              url
            }
            publisher_name {
              text
            }
          }
        }
      }
    }
    allPrismicTestimonial(
      limit: 2
      filter: {
        lang: { eq: $locale }
        data: { show_on_pages: { elemMatch: { page: { eq: $currentPage } } } }
      }
    ) {
      nodes {
        id
        data {
          fact_large {
            text
          }
          fact_small {
            text
          }
          logo {
            url
            alt
          }
          title {
            text
          }
        }
        uid
      }
    }
  }
`
